import React from "react";
import { useNavigate } from "react-router";

const Login: React.FC = () => {
  let navigate = useNavigate();

  const handleLogin = (event: React.FormEvent) => {
    event.preventDefault();

    navigate("/");
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-gray-100">
      <div className="w-full max-w-md rounded-2xl bg-white p-8 shadow-lg">
        <h2 className="mb-6 text-center text-2xl font-bold text-gray-800">
          Iniciar Sesión
        </h2>

        <form className="space-y-5">
          <div>
            <label
              htmlFor="email"
              className="block text-sm font-medium text-gray-600"
            >
              Correo electrónico
            </label>
            <input
              id="email"
              type="email"
              required
              placeholder="tu@email.com"
              className="mt-1 w-full rounded-lg border border-gray-300 p-3 text-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-500"
            />
          </div>

          <div>
            <label
              htmlFor="password"
              className="block text-sm font-medium text-gray-600"
            >
              Contraseña
            </label>
            <input
              id="password"
              type="password"
              required
              placeholder="********"
              className="mt-1 w-full rounded-lg border border-gray-300 p-3 text-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-500"
            />
          </div>

          <button
            type="submit"
            className="w-full rounded-lg bg-blue-600 py-3 text-white font-semibold transition duration-300 hover:bg-blue-700"
            onClick={handleLogin}
          >
            Ingresar
          </button>
        </form>

        <div className="mt-6 text-center text-sm text-gray-500">
          <p>
            ¿No tienes cuenta?{" "}
            <a href="#" className="font-medium text-blue-600 hover:underline">
              Regístrate
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;
